/// <reference path="../../../node_modules/monaco-editor/monaco.d.ts" />

namespace Portico.Directives {

	import Inject = Portico.Decorators.Inject;
	import pme = Portico.Models.Enterprise;
	import ps = Portico.Services;

	export class ITcMonacoController {
		tcMonaco: string;
		theme?: string;

		$element: angular.IAugmentedJQuery;
		editor: monaco.editor.IStandaloneCodeEditor;
		diffEditor: monaco.editor.IStandaloneDiffEditor;
		ngModel: angular.INgModelController;

		diff: (source: string) => void;
		edit: () => void;
	}

	@Inject('$scope')
	export class TcMonacoController implements ITcMonacoController {
		tcMonaco: string;
		theme?: string;

		$element: angular.IAugmentedJQuery;
		editor: monaco.editor.IStandaloneCodeEditor;
		diffEditor: monaco.editor.IStandaloneDiffEditor;
		ngModel: angular.INgModelController;

		constructor(private $scope: angular.IScope) {
		}

		diff(source: string): void {
			if (this.editor) {
				this.editor.dispose();
			}

			if (this.diffEditor) {
				this.diffEditor.dispose();
			}

			this.$element[0].innerHTML = '';

			var sourceModel = monaco.editor.createModel(source, this.tcMonaco);
			var targetModel = monaco.editor.createModel(this.ngModel.$viewValue, this.tcMonaco);

			this.diffEditor = monaco.editor.createDiffEditor(this.$element[0], {
				enableSplitViewResizing: true,
				renderSideBySide: true
			});

			this.diffEditor.setModel({
				original: sourceModel,
				modified: targetModel
			});

			window.addEventListener('resize', () => {
				this.diffEditor.layout();
			});

			//this.ngModel.$formatters.push((value) => {
			//	if (angular.isUndefined(value) || value === null) {
			//		return '';
			//	} else if (angular.isObject(value) || angular.isArray(value)) {
			//		throw new Error('the monaco editor cannot use an object or an array as a model');
			//	}

			//	return value;
			//});

			this.ngModel.$render = () => {
				this.diffEditor.getModifiedEditor().setValue(this.ngModel.$viewValue || '');
				this.diffEditor.layout();
			};

			this.diffEditor.getModifiedEditor().onDidChangeModelContent((e) => {
				var value = this.diffEditor.getModifiedEditor().getValue();

				if (value !== this.ngModel.$viewValue) {
					this.$scope.$evalAsync(() => {
						this.ngModel.$setViewValue(value);
					});
				}
			});
		}

		edit(): void {
			if (this.editor) {
				this.editor.dispose();
			}

			if (this.diffEditor) {
				this.diffEditor.dispose();
			}

			this.$element[0].innerHTML = '';

			this.editor = monaco.editor.create(this.$element[0], {
				language: this.tcMonaco,
				theme: this.theme,
				lineNumbers: "on",
				value: this.ngModel.$viewValue
			});

			window.addEventListener('resize', () => {
				this.editor.layout();
			});

			this.ngModel.$formatters.push((value) => {
				if (angular.isUndefined(value) || value === null) {
					return '';
				} else if (angular.isObject(value) || angular.isArray(value)) {
					throw new Error('the monaco editor cannot use an object or an array as a model');
				}

				return value;
			});

			this.ngModel.$render = () => {
				this.editor.setValue(this.ngModel.$viewValue || '');
				this.editor.layout();
			};

			this.editor.onDidChangeModelContent((e) => {
				var value = this.editor.getValue();

				if (value !== this.ngModel.$viewValue) {
					this.$scope.$evalAsync(() => {
						this.ngModel.$setViewValue(value);
					});
				}
			});
		}
	}

	angular.module('app').directive('tcMonaco', ['$timeout', ($timeout: angular.ITimeoutService) => {
		return {
			bindToController: {
				tcMonaco: '@',
				theme: '@'
			},
			controller: <any>TcMonacoController,
			controllerAs: '$monaco',
			link: ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attr: angular.IAttributes, $ctrl: any[]) => {
				const tcMonaco: ITcMonacoController = $ctrl[0];
				const ngModel: angular.INgModelController = $ctrl[1];

				const theme = tcMonaco.theme && tcMonaco.theme === 'vs-dark' ? 'vs-dark' : 'vs';

				tcMonaco.$element = $element;
				tcMonaco.ngModel = ngModel;

				(<any>window).require(["vs/editor/editor.main"], () => {
					tcMonaco.edit();

					$timeout(() => {
						tcMonaco.editor.layout();
					}, 500, true);
				});
			},
			restrict: 'A',
			require: ['tcMonaco', '^ngModel'],
			scope: true
		};
	}]);
}